var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        class: [{ "star-1": _vm.spin }, "star"],
        attrs: {
          d:
            "M8.37461 15.7427C8.3729 13.7871 7.59516 11.9122 6.21234 10.53C4.82952 9.14779 2.95475 8.37137 1 8.37137C2.95475 8.37137 4.82952 7.59495 6.21234 6.21274C7.59516 4.83052 8.3729 2.95561 8.37461 1C8.37461 2.95501 9.1509 4.82994 10.5327 6.21234C11.9145 7.59474 13.7886 8.37137 15.7427 8.37137C13.7886 8.37137 11.9145 9.148 10.5327 10.5304C9.1509 11.9128 8.37461 13.7877 8.37461 15.7427Z",
          fill: "url(#paint0_linear_6444_153673)"
        }
      }),
      _vm._v(" "),
      _c("path", {
        class: [{ "star-2": _vm.spin }, "star"],
        attrs: {
          d:
            "M17.3737 22.7427C17.3725 21.3177 16.8058 19.9515 15.7981 18.9443C14.7905 17.9371 13.4244 17.3714 12 17.3714C13.4244 17.3714 14.7905 16.8056 15.7981 15.7984C16.8058 14.7912 17.3725 13.425 17.3737 12C17.3737 13.4246 17.9394 14.7908 18.9463 15.7981C19.9532 16.8055 21.3188 17.3714 22.7427 17.3714C21.3188 17.3714 19.9532 17.9373 18.9463 18.9446C17.9394 19.9519 17.3737 21.3182 17.3737 22.7427Z",
          fill: "url(#paint1_linear_6444_153673)"
        }
      }),
      _vm._v(" "),
      _c("path", {
        class: [{ "star-1": _vm.spin }, "star"],
        attrs: {
          d:
            "M8.37461 15.7427C8.3729 13.7871 7.59516 11.9122 6.21234 10.53C4.82952 9.14779 2.95475 8.37137 1 8.37137C2.95475 8.37137 4.82952 7.59495 6.21234 6.21274C7.59516 4.83052 8.3729 2.95561 8.37461 1C8.37461 2.95501 9.1509 4.82994 10.5327 6.21234C11.9145 7.59474 13.7886 8.37137 15.7427 8.37137C13.7886 8.37137 11.9145 9.148 10.5327 10.5304C9.1509 11.9128 8.37461 13.7877 8.37461 15.7427Z",
          stroke: "url(#paint2_linear_6444_153673)",
          "stroke-width": "1.5",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }),
      _vm._v(" "),
      _c("path", {
        class: [{ "star-2": _vm.spin }, "star"],
        attrs: {
          d:
            "M17.3737 22.7427C17.3725 21.3177 16.8058 19.9515 15.7981 18.9443C14.7905 17.9371 13.4244 17.3714 12 17.3714C13.4244 17.3714 14.7905 16.8056 15.7981 15.7984C16.8058 14.7912 17.3725 13.425 17.3737 12C17.3737 13.4246 17.9394 14.7908 18.9463 15.7981C19.9532 16.8055 21.3188 17.3714 22.7427 17.3714C21.3188 17.3714 19.9532 17.9373 18.9463 18.9446C17.9394 19.9519 17.3737 21.3182 17.3737 22.7427Z",
          stroke: "url(#paint3_linear_6444_153673)",
          "stroke-width": "1.5",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }),
      _vm._v(" "),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear_6444_153673",
                x1: "17.0872",
                y1: "16.2667",
                x2: "2.46714",
                y2: "16.1661",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#5FDD33" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.259615", "stop-color": "#8ADC6D" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.716346", "stop-color": "#3ABFEA" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#3AA1EA" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint1_linear_6444_153673",
                x1: "17.0872",
                y1: "16.2667",
                x2: "2.46714",
                y2: "16.1661",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#5FDD33" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.259615", "stop-color": "#8ADC6D" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.716346", "stop-color": "#3ABFEA" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#3AA1EA" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint2_linear_6444_153673",
                x1: "17.0872",
                y1: "16.2667",
                x2: "2.46714",
                y2: "16.1661",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#5FDD33" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.259615", "stop-color": "#8ADC6D" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.716346", "stop-color": "#3ABFEA" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#3AA1EA" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint3_linear_6444_153673",
                x1: "17.0872",
                y1: "16.2667",
                x2: "2.46714",
                y2: "16.1661",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#5FDD33" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.259615", "stop-color": "#8ADC6D" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.716346", "stop-color": "#3ABFEA" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#3AA1EA" } })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }